<template>
  <label>
    <input :type="type"
           :name="name"
           :placeholder="placeholder"
           :value="modelValue"
           :class="class_name"
           @input="updateValue"
           @focus="$emit('focus', $event)"
           @blur="$emit('blur', $event)">
  </label>
</template>
<script>
  export default {
    props: {
      modelValue: {},
      class_name: { type: Array },
      name:  { type: String, require: true },
      type:  { type: String, default: 'text' },
      placeholder: { type: String }
    },

    methods: {
      updateValue: function(e) {
        this.$emit('update:modelValue',  e.target.value)
        this.$emit('change', e.target.value)
      }
    }
  }
</script>
